var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customWebpageInsert_empty"> <form class="contact-form" style="margin-bottom:10px"> <div class="control-group customWebpageInsert_inputName"> <div class="form-group"> <label id="customWebpageInsert_labelName" for="Name">'+
((__t=( resources['X100135'] ))==null?'':__t)+
'</label> <input class="form-control" id="customWebpageInsert_inputName"> <span class="help-inline" style="color:red"></span> </div> </div> <div id="container" style="visibility:hidden; height:0px"></div> <button type="button" class="btn btn-primary btn-sm col-sm-3" id="customWebpageInsert_btnSubmit">'+
((__t=( resources['X100283'] ))==null?'':__t)+
'</button> <br> </form> </div>';
}
return __p;
};
